import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import {
  getUserProfileCall,
  putSetLanguageCall,
  getOrganizationsCall,
  putSetOrganizationCall,
  getOrganizationConfigCall,
  postOrganizationConfigCall,
  putActivateContextCall,
  getUserWarningsCall,
  getUserAuthorizeCall,
  postContactCall,
} from './api';

type sagaIteratorFunction = () => SagaIterator;

export const allSagas: sagaIteratorFunction[] = [
  getUserProfileCall.saga,
  putSetLanguageCall.saga,
  getOrganizationsCall.saga,
  putSetOrganizationCall.saga,
  getOrganizationConfigCall.saga,
  postOrganizationConfigCall.saga,
  putActivateContextCall.saga,
  getUserWarningsCall.saga,
  getUserAuthorizeCall.saga,
  postContactCall.saga,
];

export function* coreSaga(): SagaIterator {
  yield all(allSagas.map((s: sagaIteratorFunction) => fork(s)));
}
